<section class="payment-result-section">
  <div class="payment-result-card" *ngIf="status === 'complete'">
    <div class="payment-result-icon">
      <mat-icon>check</mat-icon>
    </div>

    <h1 class="payment-result-title">{{ "page.order.payment.completed" | translate }}</h1>
    <p class="payment-result-description">{{ "page.order.payment.completedDescription" | translate }}</p>

    <span class="payment-result-badge">
      <mat-icon>check_circle_outline</mat-icon>
      {{ "page.order.checkout.success" | translate }}
    </span>

    <hr class="payment-result-divider" />

    <a *ngIf="hasRemainingItems" routerLink="/cart" class="payment-result-button">
      <mat-icon>shopping_cart</mat-icon>
      {{ "page.order.payment.checkoutAnotherSubscription" | translate }}
    </a>

    <a routerLink="/landing" class="payment-result-button">
      <i class="ti ti-home"></i>
      {{ "common.returnLanding" | translate }}
    </a>
  </div>
</section>
